import styled from 'styled-components'
import SearchTitleItem from 'Components/AutoComplete/components/SearchTitleItem'
import SearchResultItem from 'Components/AutoComplete/components/SearchResultItem'

export const _PopularSearchContainer = styled.div`
  padding-bottom: 30px;
`

export const _PopularSearchItem = styled(SearchResultItem)`

`

export const _Title = styled(SearchTitleItem)`
  padding: 0;
`
